import { QueryParams, axiosInstance } from './req';

export const getPaymentUser = async (userId = '') => {
    return axiosInstance.get(`/api/paymentUser?userId=${userId}`).then(({ data }) => data);
};

export const attachPaymentMethodToCustomer = async (cardId: string, addressValue: any, type = '', userId = '') => {
    return axiosInstance
        .post(`/api/paymentUser/attach-payment-method?userId=${userId}`, { cardId, addressValue, type })
        .then(({ data }) => data);
};

export const changePaymentMethod = async (
    newSource: string,
    oldSource: string,
    addressValue: any,
    type = '',
    userId = '',
) => {
    return axiosInstance
        .post(`/api/paymentUser/change-payment-method?userId=${userId}`, { newSource, oldSource, addressValue, type })
        .then(({ data }) => data);
};

export const removePaymentMethod = async (cardId: string) => {
    return axiosInstance.post(`/api/paymentUser/detach-payment-method`, { cardId }).then(({ data }) => data);
};

export const getPaymentHistory = async (limit: number, starting_after: string, ending_before: string) => {
    return axiosInstance
        .get(
            `/api/paymentUser/payment-history?limit=${limit}&starting_after=${starting_after}&ending_before=${ending_before}`,
        )
        .then(({ data }) => data);
};

export const getInvoiceDetails = async (invoiceId: string) => {
    return axiosInstance.get(`/api/paymentUser/invoice/${invoiceId}`).then(({ data }) => data);
};
